import React from 'react';
import { toast, Flip, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const AcToast = (props) => {
    const notify = () => toast(props.message);
    return (React.createElement("div", null,
        React.createElement("button", { type: "button", onClick: notify }, "Notify !")));
};
const dismissMessage = (toastId) => {
    return toastId ? toast.dismiss(toastId) : toast.dismiss();
};
const notifyMessage = (message, role, numberOrOptions) => {
    let options = {};
    if (typeof numberOrOptions === 'number') {
        options = { autoClose: numberOrOptions };
    }
    if (typeof numberOrOptions === 'object') {
        options = numberOrOptions;
    }
    switch (role) {
        case 'INFO':
            return toast.info(message, options);
        case 'SUCCESS':
            return toast.success(message, { ...options, transition: Flip });
        case 'WARNING':
            return toast.warn(message, options);
        case 'ERROR':
            return toast.error(message, options);
        default:
            return toast(message, options);
    }
};
export default AcToast;
export { AcToast, notifyMessage, dismissMessage, ToastContainer };
AcToast.displayName = 'AcToast';
